 export interface IReminderHour {
  time: number;
  value: string;
}
